import EventCategoryModel from "./eventCategoryModel";
import EventUserModel from "./eventUserModel";

export default class EventModel {
  public eventId = "";
  public eventCategoryId = "";
  public eventCategory = new EventCategoryModel();
  public calendarId = "";
  public title = "";
  public startDate = "";
  public endDate = "";
  public eventUsers = new Array<EventUserModel>();
  public eventUserIds = new Array<string>();

  constructor(data?: any) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
